import { type Meta } from '@unhead/schema'

export function usePageHead(page: Page | null) {
  const route = useRoute()
  const runtimeConfig = useRuntimeConfig()
  const client = runtimeConfig.public.client
  const clientMapping = runtimeConfig.public.clientMapping as ClientMapping
  const clientBaseUrlMapping = runtimeConfig.public
    .clientBaseUrlMapping as ClientBaseUrlMapping

  const meta: Meta[] = [
    {
      property: 'og:type',
      content: 'website',
    },
    {
      property: 'og:site_name',
      content: clientMapping[client],
    },
    {
      property: 'og:image',
      content: `${clientBaseUrlMapping[client]}/images/og.jpg`,
    },
  ]

  if (page?.description) {
    meta.push(
      {
        name: 'description',
        content: page.description,
      },
      {
        property: 'og:description',
        content: page.description,
      }
    )
  }

  if (page?.title) {
    meta.push({ property: 'og:title', content: page.title })
  }

  if (page?.metatags?.length) {
    page.metatags.forEach((metatag) => {
      meta.push({ name: metatag.name, content: metatag.content })
    })
  }

  const trackingEnv =
    runtimeConfig.public.stage === 'int' ||
    runtimeConfig.public.stage === 'demo'
      ? 'stage'
      : 'prod'

  let matomoSiteId = ''
  switch (client) {
    case 'cab':
      matomoSiteId = '1018'
      break
    case 'srhh':
      matomoSiteId = '1028'
      break
    case 'flinkster':
      matomoSiteId = '1046'
      break
  }

  useHead({
    bodyAttrs: {
      class: computed(() => {
        return route.query.dbcembedded === '2'
          ? 'dbc-embedded-2'
          : '' + 'overflow-x-hidden'
      }),
    },
    htmlAttrs: {
      lang: route.params.locale as string,
      class: `${client} ${isWebview() ? 'webview' : ''} font-neo-screen-sans`,
    },
    title: page?.title,
    meta: [...meta],
  })

  useHead({
    ...(client !== 'srlg' && {
      script: [
        {
          type: 'text/javascript',
          tagPosition: 'head',
          innerHTML: `var cmp_data = {
            cmp_environment: "${trackingEnv}",
            cmp_profile: "b-reise",
            matomo_site_id: "${matomoSiteId}",
            cmp_theme_name:"${
              client === 'cab' || client === 'flinkster' ? 'DB' : 'NEUTRAL'
            }",
            cmp_legal_pages: ['/datenschutz', '/agb', '/impressum', '/faq', '/privacy-statement', '/gtc', '/imprint', '/support', '/kontakt', '/contact', '/produktupdate', '/productupdate', '/sitemap', '/embedded-anmelden', '/embedded-kundenbereich', '/embedded-login', '/embedded-self-service', '/embedded-kundenbereich/daten/email/aendern', '/embedded-self-service/data/update/email', 'embedded-kundenbereich/daten/passwort/aendern', '/embedded-self-service/data/update/password', '/embedded-kundenbereich/daten/telefonnummer/aendern', '/embedded-self-service/data/update/phone', '/embedded-kundenbereich/zahlungsmittel/aendern', '/embedded-self-service/payment/update']
            };`,
          async: false,
        },
        {
          type: 'text/javascript',
          tagPosition: 'head',
          innerHTML: `var _mtm = window._mtm = window._mtm || [];
            _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
            (function() {
              var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
              g.async=true; g.src='https://dbwas.service.deutschebahn.com/piwik/js/container_R4aFmA2c.js'; s.parentNode.insertBefore(g,s);
            })();`,
          async: false,
        },
      ],
    }),
  })

  useHead({
    ...(client === 'flinkster' &&
      !isWebview() && {
        script: [
          {
            src: 'https://userlike-cdn-widgets.s3-eu-west-1.amazonaws.com/cad1af705f954a41acffb2ff06cc7d20a5da3fc629df4367983ad70a21328b0f.js',
            type: 'text/javascript',
            tagPosition: 'bodyClose',
            async: true,
          },
        ],
      }),
    ...(client !== 'flinkster' &&
      !isWebview() && {
        script: [
          {
            src: 'https://userlike-cdn-widgets.s3-eu-west-1.amazonaws.com/9ab861b556b348b2afeb6d7e175ca1bc11b5e22b1c9d473c90b0a5a0b7a13753.js',
            type: 'text/javascript',
            tagPosition: 'bodyClose',
            async: true,
          },
        ],
      }),
  })
}
